import { CURRENT_YEAR } from '@fingo/lib/constants/dates';

const CREDENTIALS_REQUIRED_DOCUMENTS = [
  {
    name: `Balance ${CURRENT_YEAR}`,
    code: 'balance',
    years: 1,
    template: null },
  {
    name: 'Contrato marco',
    code: 'contract',
    years: null,
    template: null,
  },
];

export default CREDENTIALS_REQUIRED_DOCUMENTS;
